import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect = () => {
    document.addEventListener('contextmenu', this.handleContextMenu)
  }

  handleContextMenu = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }
}
